import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Img, Text, useDisclosure, VStack } from "@chakra-ui/react"
import { ReactNode, useRef } from "react"
import { useScreenSize } from "../../../providers/ScreenSizeProvider";

interface PayoutUpdateDialogProps {
    children: ReactNode
    onConfirm?: () => void;
}

export const PayoutUpdateDialog = ({ children, onConfirm }: PayoutUpdateDialogProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = useRef<any>()
    const { isMobile } = useScreenSize()

    const open = async () => {
        onOpen()
    }

    const confirm = ()=> {
        if(onConfirm){
            onConfirm()
        }
        onClose()
    }


    return (
        <>
            <Box cursor={'pointer'} onClick={open}>
                {children}
            </Box>
            <AlertDialog
                motionPreset='slideInBottom'
                leastDestructiveRef={cancelRef}
                onClose={onClose}
                isOpen={isOpen}
                size={isMobile ? 'xs' : 'xl'}
            >
                <AlertDialogOverlay />

                <AlertDialogContent bg={'#1F1C2C'}>
                    <AlertDialogHeader>
                        Update Payout Account
                    </AlertDialogHeader>
                    <AlertDialogCloseButton />
                    <AlertDialogBody>
                        <Text color={'gray.300'} fontSize={'md'} fontWeight={400}>
                            You are about to update your payout information, Do you really want to continue ?
                        </Text>
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button _hover={{ bg: 'green.300' }} bg={'green.400'} color={'black'} onClick={()=> confirm()}>Confirm</Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </>
    )
}